export default [
    '用户185*****165成功兑换了2元地铁券',
    '用户186*****780成功兑换了2元地铁券',
    '用户136*****115成功兑换了3元地铁券',
    '用户181*****023成功兑换了3元地铁券',
    '用户139*****862成功兑换了1元地铁券',
    '用户159*****736成功兑换了1元地铁券',
    '用户139*****002成功兑换了50元话费',
    '用户185*****689成功兑换了50元话费',
    '用户135*****523成功兑换了50元建行生活美食券',
    '用户176*****337成功兑换了50元话费',
    '用户135*****606成功兑换了爱奇艺月卡',
    '用户159*****783成功兑换了爱奇艺月卡',
    '用户150*****603成功兑换了20元建行生活美食券',
    '用户150*****517成功兑换了30元建行生活美食券',
    '用户186*****023成功兑换了100元京东E卡'
]